
import { RQ } from 'utils';
import * as F from 'utils/F';
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import { addClickAnalytics } from 'utils/analytics';
import { Popup, Button, Loading } from 'vant';
import { yoButton } from 'components';

import { dateFormat } from 'utils/filters';
import action from './action';

export default {
name: 'result',
props: ['params'],
metaInfo() {
return {
title: this.pageTitle
};
},
created: async function () {
if (this.step == 2) {


this.getInfo();
}
},
data() {
const redirect = decodeURIComponent(this.$route.query.redirect);
console.log('redirect', redirect);
let form = undefined;
if (redirect.indexOf('/goods/') != -1) {
form = 'goods';
}
if (redirect.indexOf('/login') != -1) {
form = 'login';
}
console.log('redirect', form);
return {
pageTitle: this.params.loginType == 1 ? '登陆成功' : '注册成功',
from: form,
redirect: redirect,
step: this.params.loginType || '',
showCouponPopup: false,
enterpriseNo: this.params.enterprise,
inviteCode: this.params.inviteCode,
coupons: undefined
};
},
computed: {},
filters: {
dateFormat
},
components: {
yoButton,
'van-popup': Popup,
Group,
XInput,
'van-button': Button,
'van-loading': Loading
},
methods: {
...action
}
};




// WEBPACK FOOTER //
// ./src/module/member/result/page.vue